import { useState, useEffect, useCallback } from "react";
import ChatSidebar from "./ChatSidebar";
import ChatInterface from "./ChatInterface";
import { owlService } from "../../Services";
import { useNavigate, useParams } from "react-router-dom";
import LoadingBackDrop from "../../Components/Base/Common/LoadingBackDrop";
import NotSubscribe from "../../Components/Base/Common/NotSubscribe";
import { storageHandler } from "../../Helpers/storage";
import { parseInput } from "../../Components/Constants/AppConstant";
import Toast from "../../Components/Base/Form/Toast";
export default function Owl({
  cartItem,
  closeCartPanel,
  setAuth,
  setModal,
  user,
  NotifModul,
  profiles,
  setModalNotification,
  locationData,
  goToPricing,
}) {
  // State Management
  const [allConversation, setConversations] = useState([]);
  const [chatHistory, setChatHistory] = useState();
  console.log("chatHistory", chatHistory);
  const [activeSessionId, setActiveSessionId] = useState("");
  const [currentMessages, setCurrentMessages] = useState([]);

  // Pagination States
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [currentChatPage, setCurrentChatPage] = useState(1);
  const [hasMoreMessages, setHasMoreMessages] = useState(false);
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);
  const [isChatLoading, setIsChatLoading] = useState(false);
  const [toastList, setToastList] = useState([]);

  const navigate = useNavigate();
  const { sessionId } = useParams();

  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  const fetchAllConversation = useCallback(
    async (pageNum, preventAutoSelect) => {
      if (isLoading) return;
      setIsLoading(true);

      try {
        const limit = 20;
        const response = await owlService.getAllConversations(
          pageNum || 1,
          limit
        );

        setConversations((prev) =>
          pageNum === 1 ? response.data : [...prev, ...response.data]
        );
        setHasMore(response.data.length === limit);

        // Only auto-select if no sessionId exists and not prevented
        if (
          !(preventAutoSelect === true) &&
          !sessionId &&
          (pageNum || 1) === 1 &&
          response.data.length > 0
        ) {
          if (response.data[0].title === "New Conversation") {
            updateRouteId(response.data[0].session_id);
          } else {
            handleNewChat(true);
          }
        }
      } catch (err) {
        if (err.apiResponseStatus != 404) {
          let error = parseInput(err.message);
          addToast({
            error: true,
            msg: error.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        } else {
          setIsLoading(true);
        }
      }
    },
    [isLoading, sessionId]
  );

  const fetchChatHistory = useCallback(
    async (sessionID, pageNum = 1, append = false) => {
      if (isLoadingMessages && append) return null;
      if (append) setIsLoadingMessages(true);

      try {
        const limit = 20;
        const response = await owlService.getChatHistory(
          sessionID,
          pageNum,
          limit
        );

        let messages = response.data.messages.reverse();
        if (append) return messages;
        // if (append) return response.data.messages;

        setChatHistory(response);
        setCurrentChatPage(1);
        setHasMoreMessages(
          parseInt(response.data.pagination?.total_pages || 0) > 1
        );

        return response.data.messages;
      } catch (err) {
        if (err.apiResponseStatus != 404) {
          let error = parseInput(err.message);
          addToast({
            error: true,
            msg: error.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        } else {
          setIsLoadingMessages(true);
        }
      } finally {
        if (append) setIsLoadingMessages(false);
      }
    },
    [isLoadingMessages]
  );

  // Chat Operations
  const loadMoreMessages = useCallback(async () => {
    if (!activeSessionId || !hasMoreMessages || isLoadingMessages) return;

    setIsLoadingMessages(true);
    try {
      const nextPage = currentChatPage + 1;
      const response = await owlService.getChatHistory(
        activeSessionId,
        nextPage,
        20
      );

      if (response.data?.messages?.length) {
        const container = document.querySelector(".flex-1.overflow-y-auto");
        const previousScrollHeight = container?.scrollHeight || 0;
        setCurrentMessages((prev) => [...response.data.messages, ...prev]);
        setCurrentChatPage(nextPage);
        setHasMoreMessages(
          nextPage < parseInt(response.data.pagination?.total_pages || 0)
        );

        setTimeout(() => {
          if (container) {
            container.scrollTop = container.scrollHeight - previousScrollHeight;
          }
        }, 0);
      } else {
        setHasMoreMessages(false);
      }
    } catch (error) {
      console.error("Failed to load more messages:", error);
      setHasMoreMessages(false);
    } finally {
      setIsLoadingMessages(false);
    }
  }, [activeSessionId, currentChatPage, hasMoreMessages, isLoadingMessages]);

  const handleSendMessage = async (messageText) => {
    const newMessage = createMessage(messageText, "user");
    setCurrentMessages((prev) => [...prev, newMessage]);
    const loadingMessage = createLoadingMessage();
    setCurrentMessages((prev) => [...prev, loadingMessage]);

    try {
      const response = await processMessageStream(messageText);
      if (response) {
        setCurrentMessages((prev) => prev.filter((msg) => !msg.isLoading));
        const aiResponse = createAiResponse(response);
        setCurrentMessages((prev) => [...prev, aiResponse]);
        updateConversationList(newMessage, aiResponse, messageText);
      }
    } catch (error) {
      handleMessageError(error, newMessage);
    }
  };

  // Helper Functions
  const createMessage = (content, role) => ({
    id: Date.now().toString(),
    content,
    role,
    timestamp: new Date().toLocaleTimeString(),
  });

  const createLoadingMessage = () => ({
    id: `loading-${Date.now()}`,
    content: "...",
    role: "owl",
    isLoading: true,
    timestamp: new Date().toLocaleTimeString(),
  });

  const processMessageStream = async (messageText) => {
    const response = await owlService.streamChat({
      session_id: activeSessionId,
      message: messageText,
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    if (!response.body) throw new Error("ReadableStream not supported");

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let aiResponseText = "";
    let hasError = false;

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value, { stream: true });
      if (chunk.trim().startsWith("{")) continue;
      if (chunk.includes("--END--")) continue;
      if (chunk.includes("⚠️ TamaOwl failed to reply")) {
        hasError = true;
        continue;
      }

      aiResponseText += chunk;
    }

    return hasError
      ? "Sorry, I encountered an error while processing your request."
      : aiResponseText.trim();
  };

  const createAiResponse = (content) => ({
    id: (Date.now() + 1).toString(),
    content,
    role: "owl",
    timestamp: new Date().toLocaleTimeString(),
  });

  const handleMessageError = (error, userMessage) => {
    const errorResponse = createAiResponse(
      "Sorry, I couldn't process your message. Please try again."
    );
    setCurrentMessages((prev) => [...prev, errorResponse]);
    updateConversationList(userMessage, errorResponse, userMessage.content);
  };

  // Navigation and Selection
  const updateRouteId = (sessionId) => {
    navigate(`/brand/owl/${sessionId}`);
  };

  const getChatHistory = async (sessionID) => {
    setIsChatLoading(true);
    const selectedChat = await fetchChatHistory(sessionID);
    if (selectedChat) {
      setActiveSessionId(sessionID);
      setCurrentMessages(selectedChat);
      setCurrentChatPage(1);
    }
    setIsChatLoading(false);
  };

  const handleSelectChat = (sessionId) => {
    updateRouteId(sessionId);
  };

  const handleDeleteChat = async (sessionIdToDelete) => {
    try {
      await owlService.deleteChat(sessionIdToDelete);

      const wasActiveChat = activeSessionId === sessionIdToDelete;
      const remainingChats = allConversation.filter(
        (chat) => chat.session_id !== sessionIdToDelete
      );

      if (wasActiveChat) {
        setCurrentMessages([]);

        if (remainingChats.length > 0) {
          updateRouteId(remainingChats[0].session_id);
        } else {
          const response = await owlService.createNewConversation();
          if (response.success) {
            updateRouteId(response.data.session_id);
          }
        }
      }
      fetchAllConversation(1, true);
    } catch (error) {
      console.error("Failed to delete chat:", error);
    }
  };
  const updateConversationList = (userMessage, aiMessage, messageText) => {
    const chatTitle =
      messageText.length > 50
        ? `${messageText.substring(0, 50)}...`
        : messageText;

    if (activeSessionId) {
      setConversations((prev) =>
        prev.map((chat) =>
          chat.id === activeSessionId
            ? { ...chat, messages: [...chat.messages, userMessage, aiMessage] }
            : chat
        )
      );
    } else {
      const newChatId = Date.now().toString();
      setConversations((prev) => [
        {
          id: newChatId,
          title: chatTitle,
          timestamp: "today",
          messages: [userMessage, aiMessage],
        },
        ...prev,
      ]);
      setActiveSessionId(newChatId);
    }
  };

  const handleLoadMore = () => {
    if (!isLoading && hasMore) {
      setPage((prev) => prev + 1);
      fetchAllConversation(page + 1);
    }
  };

  const handleNewChat = async (isCallOrEvent = false) => {
    const isCall = typeof isCallOrEvent === "boolean" ? isCallOrEvent : false;

    if (currentMessages.length === 0 && !isCall) return;

    try {
      const response = await owlService.createNewConversation();
      if (response.success) {
        setActiveSessionId(response.data.session_id);
        setCurrentMessages([]);
        setCurrentChatPage(1);
        setHasMoreMessages(false);
        updateRouteId(response.data.session_id);
      }
    } catch (error) {
      console.error("Failed to create new chat:", error);
    }
  };

  // Effects
  useEffect(() => {
    if (sessionId) {
      getChatHistory(sessionId);
    } else {
      fetchAllConversation(1);
    }
  }, [sessionId]);

  useEffect(() => {
    fetchAllConversation(1);
  }, []);

  let data = null;
  try {
    const userInfo = storageHandler.getUserInfo();
    if (userInfo) {
      const parsed = JSON.parse(userInfo);
      data = parsed?.data || null;
    }
  } catch (error) {
    console.error("Error parsing user info:", error);
  }
  useEffect(() => {
    data.p_f_ids.includes(14);
  }, []);

  return (
    <>
      {data.p_f_ids.includes(14) ? (
        <>
          <div className="sm:h-screen md:h-[calc(100vh-195px)] lg:h-[calc(100vh-120px)] xl:h-[calc(100vh-120px)] 2xl:h-[calc(100vh-110px)] flex flex-col overflow-hidden ">
            <div className="flex flex-1 bg-background text-foreground overflow-hidden">
              <ChatInterface
                messages={currentMessages}
                onSendMessage={handleSendMessage}
                loadMoreMessages={loadMoreMessages}
                isLoadingMore={isLoadingMessages}
                hasMoreMessages={hasMoreMessages}
              />
              <ChatSidebar
                allConversation={allConversation}
                onNewChat={handleNewChat}
                onSelectChat={handleSelectChat}
                onDeleteChat={handleDeleteChat}
                activeSessionId={activeSessionId}
                onLoadMore={handleLoadMore}
                hasMore={hasMore}
                isLoading={isLoading}
              />
              <LoadingBackDrop
                open={isChatLoading}
                message="Loading Chats..."
                size={60}
                thickness={4}
              />
            </div>
          </div>
          {toastList.length > 0 && (
            <Toast type="rate" list={toastList} setList={setToastList} />
          )}
        </>
      ) : (
        <>
          <NotSubscribe
            goToPricing={goToPricing}
            type="brand"
            setAuth={setAuth}
            setModal={setModal}
            NotifModul={NotifModul}
            setNotifModul={setModalNotification}
            profiles={profiles}
            closeCartPanel={closeCartPanel}
            user={user}
            cartItem={cartItem}
            title={"Chat"}
            background={"background_inflist.png"}
          ></NotSubscribe>
        </>
      )}
    </>
  );
}
